var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeartCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#FE4141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.33 17.0004C12.15 17.0604 11.84 17.0604 11.66 17.0004C10.1 16.4704 6.60001 14.2404 6.60001 10.4604C6.60001 8.79042 7.94001 7.44043 9.60001 7.44043C10.58 7.44043 11.45 7.91042 12 8.65042C12.54 7.92042 13.42 7.44043 14.4 7.44043C16.06 7.44043 17.4 8.79042 17.4 10.4604C17.4 14.2404 13.9 16.4704 12.33 17.0004Z",
    fill: "#FE4141"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartCircle);
export default __webpack_public_path__ + "static/media/heart-circle.66b6c8e343f9844456eecc113d416b29.svg";
export { ForwardRef as ReactComponent };